import React from 'react';
import { AnchorBreakdown as Breakdown } from '../../types/speakerCorrection';

interface Props {
  breakdown: Breakdown;
  convergenceScore: number;
}

const ANCHOR_LABELS: Record<keyof Breakdown, string> = {
  acoustic: 'Acoustic',
  role: 'Role',
  conversation: 'Conversation',
  clinical: 'Clinical',
  chart: 'Chart',
};

export function AnchorBreakdownView({ breakdown, convergenceScore }: Props) {
  return (
    <div className="text-xs space-y-1 bg-slate-50 border rounded p-2">
      <table className="w-full">
        <thead>
          <tr className="text-slate-500">
            <th className="text-left font-medium">Anchor</th>
            <th className="text-right font-medium">Score</th>
            <th className="text-left font-medium pl-2">Evidence</th>
          </tr>
        </thead>
        <tbody>
          {(Object.keys(breakdown) as Array<keyof Breakdown>).map((k) => (
            <tr key={k}>
              <td className="font-medium">{ANCHOR_LABELS[k]}</td>
              <td className="text-right tabular-nums">{breakdown[k].score.toFixed(2)}</td>
              <td className="pl-2 text-slate-600">{breakdown[k].evidence}</td>
            </tr>
          ))}
          <tr className="border-t font-semibold">
            <td>Convergence</td>
            <td className="text-right tabular-nums">{convergenceScore.toFixed(2)}</td>
            <td className="pl-2 text-slate-500">→ threshold 0.90 for auto-correct</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
